<template>
  <div class="article-2">
    <div class="article__info">
      <h1 class="article__title">首投族改變選舉結果？</h1>
      <h2 class="article__subtitle">藍綠要搶首投族 先拚執政縣市動員</h2>
      <div class="article__reporter">聯合報 記者：蔡晉宇、張文馨、鄭媁／報導</div>
    </div>

    <figure class="article__figure article__cover">
      <div class="article__figure-photo" :style="`background-image: url(${require('@/assets/articles/article-2-cover.jpg')})`"></div>
      <figcaption class="article__figure-caption">
        <SvgSymbol class="article__figure-caption-icon" use="#figure-caption-icon"/>
        <span>韓國瑜和年輕人舉行座談會。記者徐兆玄／攝影</span>
      </figcaption>
    </figure>

    <p class="article__paragraph">根據中選會公布的資料，2020年選舉人總數預計有1934萬76人，總統和立委的20歲到23歲首投族人數，共有118萬6685人，比率約占6.14%，這是藍綠認為足以逆轉勝的關鍵數字。</p>
    <p class="article__paragraph">首投族因為是第一次投票，各界認為會有「嘗鮮」的心態下，投票率相對較高。不過，以內政部公布人口年齡結構、中選會2016年總統大選投票結果與投票行為抽樣分析結果，可以清楚看出，從年齡分布的數據顯示，首投族的投票行為本身就有差異；但有趣的是，投票率最高、最低，剛好落在首投族交界的20歲與24歲。</p>
    <p class="article__paragraph">從中選會在投票行為的抽樣研究中發現，以20到39歲的級距，全國平均投票率僅57.73%。這個年齡層當中，以20歲的投票率最高，達到62.06%；24歲投票率最低，只有55%。</p>
    <p class="article__paragraph">20歲首次行使公民權，因為是人生首度正式參政，返鄉投票意願可能較高。24歲這一群人，因為四年前投過一次，已無新鮮感，若缺乏強大誘因，加上投票成本較高，投票率自然容易低落。</p>
    <p class="article__paragraph">再觀察不同年齡在同一次選舉的投票率變化，趨勢將更清楚。年輕族群的投票率在20歲、21歲都維持六成，之後一路都低於平均值，但隨著年齡增長，投票率就呈現逐步上揚的趨勢。</p>
    <p class="article__paragraph">世新大學行管系教授莊文忠指出，整體來說，年輕族群的政治參與程度，過去研究顯示並不高，觀察2016年投票率也有類似現象。</p>

    <!-- chart-1 -->
    <div class="article__chart">
      <div class="article__chart-caption">20-39歲的各年齡層投票率</div>
      <div class="article__chart-figure article-2__chart-figure-1">
        <SvgSymbol use="#article-1-chart-4"/>
      </div>
      <div class="article__chart-annotation"><!--
      --><span>資料來源：內政部、中選會2016投票紀錄</span><!--
      --><span>本文自行彙整</span>
      </div>
    </div>

    <p class="article__paragraph">莊文忠進一步指出，年輕族群平均投票率低於整體，24歲群組投票率低於全體投票率超過一成，可從投票成本來觀察，假設24歲開始步入社會，籍在、人不在的可能性高，投票必須自費返鄉；但隨著年歲增漸，購屋、生子、遷戶籍，投票成本降低，投票率就會回升。</p>
    <p class="article__paragraph">以人數較多的六都來觀察，投票率表現普遍略高於其他地區。除了投票成本外，六都動員也較密集，不少候選人會在投票前夕舉辦活動，讓年輕人「熬夜投完票再回家睡覺」。</p>
    <p class="article__paragraph">居住在都市化程度較高的年輕人，投票率會跟著提升外；年輕人是否願意投票的另一個關鍵點是「藍綠執政縣市」。</p>

    <h3 class="article__paragraph-title">綠營執政縣市 年輕人投票率較高</h3>
    <p class="article__paragraph">觀察2016總統大選的實際投票，綠營執政縣市平均投票率為66.8%，藍營是64.9%；再進一步分析抽樣調查結果，綠營執政縣市年輕人投票率為58.4%，藍營55.9%。藍綠差距從原本1.9個百分點，在39歲以下的選民擴大到2.5個百分點，顯示綠營執政縣市激發年輕人投票的動員力高，策略效果也較好。</p>
    <p class="article__paragraph">再以每年齡為一組分組觀察，綠執政在各年齡分組投票率，普遍高於藍營，僅25、29和38歲呈現交叉。整體而言，綠營執政的縣市，年輕人的投票意願會高於藍營執政縣市。</p>

    <!-- chart-2 -->
    <div class="article__chart">
      <div class="article__chart-caption">藍綠政黨執政縣市之投票率</div>
      <div class="article__chart-figure article-2__chart-figure-2">
        <SvgSymbol use="#article-2-chart-2"/>
      </div>
      <div class="article__chart-annotation"><!--
      --><span>資料來源：內政部、中選會2016投票紀錄</span><!--
      --><span>本文自行彙整</span>
      </div>
    </div>

    <p class="article__paragraph">因此，首投族的年齡不是投票關鍵，青年返鄉投票的效果也不如預期，反倒是藍綠如何透過執政優勢、多元化策略或是更吸引年輕人的方式，鼓勵年輕人前往投票，才是真正影響投票率高低、衝擊選情。</p>
  </div>
</template>

<script>
// import Dictionary from '@/components/Dictionary'

export default {
  name: 'Article2',
  components: {
    // Dictionary
  }
}
</script>

<style lang="scss">
.article-2 {
  &__chart-figure {
    &-1 {
      @include use-fixed-ratio(726, 312);
    }

    &-2 {
      @include use-fixed-ratio(704, 416);
    }

    .svg-symble {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
